import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "shared/types";

export const _selectQuestions = (state: RootState) => state.workbook.questions;

export const selectQuestionsByFlavor = (flavor?: string) =>
  createSelector([_selectQuestions, () => flavor], (questions, _flavor) =>
    _flavor
      ? Object.values(questions).filter((question) => question.flavor === _flavor)
      : Object.values(questions),
  );

export const _selectWorkbooks = (state: RootState) => state.workbook.workbooks;

export const selectWorkbooksByFlavor = (flavor?: string) =>
  createSelector([_selectWorkbooks, () => flavor], (workbooks, _flavor) =>
    _flavor
      ? Object.values(workbooks).filter((question) => question.flavor === _flavor)
      : Object.values(workbooks),
  );
